<template>
  <Register mode="guest" />
</template>
<script>
import Register from './Register.vue';
export default { components: {Register } };
</script>
